import { render, staticRenderFns } from "./CoTwoTransportCarLodgesForm.vue?vue&type=template&id=abc93258&scoped=true&"
import script from "./CoTwoTransportCarLodgesForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoTransportCarLodgesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc93258",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abc93258')) {
      api.createRecord('abc93258', component.options)
    } else {
      api.reload('abc93258', component.options)
    }
    module.hot.accept("./CoTwoTransportCarLodgesForm.vue?vue&type=template&id=abc93258&scoped=true&", function () {
      api.rerender('abc93258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoTransportCarLodgesForm.vue"
export default component.exports